import React, { useEffect } from "react";
import { Navigate, Route } from "react-router-dom";
import useMaster from "../hooks/useMaster";


const AuthProtected = (props) => {
  return <div>
  {props.children}
  </div>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };